import { zCorpOrderDom, zCorpReportDom } from "@/types/company/report.domain";
import { zCorpOrderRowDto, zCorpReportDto } from "@/types/company/report.dto";
export const CompanyReportMapper = {
    /** Ответ `corp_report_orders` (§4.3). */
    reportToDomain(raw) {
        const dto = zCorpReportDto.parse(raw);
        return zCorpReportDom.parse({
            companyId: dto.companyId,
            dateFrom: dto.dateFrom,
            dateTo: dto.dateTo,
            groupBy: dto.groupBy,
            totals: dto.totals,
            rows: dto.rows,
        });
    },
    /** Строка `v_corp_orders`; техник/маршрут/ETA — `null` при отменённом маршруте (CCR-036). */
    orderToDomain(raw) {
        const row = zCorpOrderRowDto.parse(raw);
        return zCorpOrderDom.parse({
            orderId: row.order_id,
            companyId: row.company_id,
            linkId: row.link_id ?? null,
            orderNumber: row.order_number,
            status: row.status,
            employeeLabel: row.employee_label ?? null,
            clientName: row.client_name ?? null,
            phoneE164: row.phone_e164 ?? null,
            scheduledDate: row.scheduled_date ?? null,
            scheduledDateEnd: row.scheduled_date_end ?? null,
            address: row.address ?? null,
            vehicle: row.vehicle
                ? {
                    brand: row.vehicle.brand ?? null,
                    model: row.vehicle.model ?? null,
                    stateNumber: row.vehicle.stateNumber ?? null,
                }
                : null,
            planTotalKwh: row.plan_total_kwh ?? null,
            planCost: row.plan_cost ?? null,
            actualTotalKwh: row.actual_total_kwh ?? null,
            actualCost: row.actual_cost ?? null,
            pricePerKwhSnapshot: row.price_per_kwh_snapshot ?? null,
            serviceFeeSnapshot: row.service_fee_snapshot ?? null,
            technicianName: row.technician_name,
            eta: row.eta,
            createdAt: row.created_at,
            chargedAt: row.charged_at,
            isCharged: row.is_charged,
            invoiceId: row.invoice_id ?? null,
            invoiceNumber: row.invoice_number ?? null,
            clientId: row.client_id ?? null,
            technicianId: row.technician_id ?? null,
            routeId: row.route_id ?? null,
        });
    },
};
